import { Integration_Auth_Names_Enum, Integration_Names_Enum } from '@main/graphql/types.generated';
import {
  integrationSchemaRegistry,
  isPublicHostname,
  pemPrivateKeySchema,
} from '@main/shared/utils';
import { z } from 'zod/v4';

import { IntegrationAuth, IntegrationConnector, IntegrationConnectorCategory } from '../../lib';

export type OktaConnectorConfig = typeof OktaConnector._.Config;

const oktaOrgUrlSchema = z
  .url({
    protocol: /^https$/,
    error: 'Use an https:// URL for your Okta organization.',
    abort: true,
  })
  .refine((value) => isPublicHostname(new URL(value).hostname), {
    error: 'Use the public hostname of your Okta organization, not an IP address or a local name.',
    abort: true,
  })
  .refine((value) => new URL(value).href === `${new URL(value).origin}/`, {
    error:
      'Use your Okta organization URL without credentials, a path, a query, or a fragment, such as https://acme.okta.com.',
  });

export const OktaConnector = IntegrationConnector.make({
  provider: Integration_Names_Enum.Okta,
  logoPath: 'images/okta-logo.svg',
  categories: [IntegrationConnectorCategory.Identity],
  auths: IntegrationAuth.group([
    IntegrationAuth.manual({
      name: Integration_Auth_Names_Enum.AppPrivateKey,
      configSchema: z.object({
        baseUrl: oktaOrgUrlSchema,
        clientId: z.string(),
      }),
      encryptedConfigSchema: z.object({
        privateKey: pemPrivateKeySchema().register(integrationSchemaRegistry, {
          presentation: { input: 'textarea' },
        }),
      }),
    }),
  ]),
});
